{
    "LockedOut": "Gebruikersrollen",
    "PromptTos": "Servicemelding:",
    "NotifyPasswordChange": "Wachtwoordwijziging doorgeven:",
    "UpdateInterval": "Update-interval rapport:",
    "UpdateIntervalCharacter": "s",
    "UpdateIntervalValidation": "Update-interval rapport heeft een maximum van 180 seconden",
    "MediaPlayer": "Schakel plug-ins voor mediaspelers uit:",
    "DragAndDrop": "of hier slepen en neerzetten.",
    "JavascriptOutput": "Afdrukuitvoeropties",
    "AutoValue": "[Auto]",
    "SettingsLanguage_ServiceNotification": "Servicemelding:",
    "SettingsLanguage_ConcurrentSignins": "Gelijktijdige aanmeldingen toegestaan:",
    "SettingsLanguage_AdvancedTitle": "Geavanceerde diagnostiek",
    "NAME": "SettingsLanguage",
    "SettingsLanguage_AuthNotifications": "Auth-melding:",
    "SettingsLanguage_NewDeviceNotifications": "Kennisgevingen voor provisioning:",
    "SettingsLanguage_AuthNotifications_Help": "Als je Auth Notifications inschakelt, ontvangt de beheerder een e-mail als een MS Teams Telephony Server is geautoriseerd.",
    "SettingsLanguage_NewDeviceNotifications_Help": "Het inschakelen van Provisioning Notifications betekent dat de beheerder een e-mail ontvangt wanneer een nieuw apparaat wordt toegevoegd of de integratiemodus wordt gewijzigd op een MS Teams Instance."
}